import React from 'react'
import { useEffect, useState } from "react";
import axios from "axios";
import {
  XMarkIcon,
  ExclamationCircleIcon,
  UsersIcon,
} from "@heroicons/react/20/solid";
import Loader from '../../../utils/Loader';
import { useNavigate } from "react-router-dom";
import ChitDetailsAddPayment from '../chitdetails/ChitDetailsAddPayment';
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from 'react'


const DashboardList = () => {

  const [loading, setLoading] = useState(false)
  const [statsData, setStatsData] = useState({})
  const navigate = useNavigate();
  const [error, setError] = useState(null)
  const [formData, setFormData] = useState([])
  const [customerId, setCustomerId] = useState(null)
  const [chitDetailsAddPayment, setChitDetailsAddPayment] = useState(false)
  const [currentMonthPayout, setCurrentMonthPayout] = useState([])
  const [previouMonthPayout, setPreviouMonthPayout] = useState([])
  const [search, setSearch] = useState("")

  const fetchData = async (page = 1) => {
    try {
      setLoading(true)
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `public/api/dashboard-stats`,
        { headers: { Authorization: `Bearer ${token}` } }
      )



      if (response?.data?.success) {
        setStatsData({
          customers: response?.data?.customers || "0",
          groups: response?.data?.groups || "0",
          plan: response?.data?.plan || "0",
          activePlans: response?.data?.activePlans || "0",
          currentMonthPayout: response?.data?.currentMonthPayoutTotal || "0",
          currentMonthPending: response?.data?.currentMonthPending || "0",
          previousMonthPayout: response?.data?.previousMonthPayoutTotal || "0",
          previousMonthPending: response?.data?.previousPendings || "0",
        })
      }
      setCurrentMonthPayout(response?.data?.currentMonthPayoutStats)
      setPreviouMonthPayout(response?.data?.previousMonthPayoutStats)


      let endpoint = `public/api/chit/details?$page=${page}`;

      const response1 = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      setFormData(response1?.data?.chit_details?.data)
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm");
      }
      setError(error.response?.data?.messaage || " Please check your internet connection and try again.")
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    fetchData()
  }, [])



  const searchFilter = async (page = 1) => {
    try {
      setLoading(true)
      const token = localStorage.getItem("token");
      let endpoint = `public/api/chit/details?$page=${page}`;
      if (search) {
        endpoint += `&search=${search}`
      }
      const response1 = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      setFormData(response1?.data?.chit_details?.data)

    } catch (error) {

    } finally {
      setLoading(false)
    }
  }
  const stats = [
    {
      title: "Customer",
      value: statsData?.customers,
      icon: UsersIcon
    },
    {
      title: " Groups",
      value: statsData?.groups,
      icon: UsersIcon
    },
    {
      title: "Plan",
      value: statsData?.plan,
      icon: UsersIcon
    },
    {
      title: "Active Plan",
      value: statsData?.activePlans,
      icon: UsersIcon

    },
    {
      title: "This Month Pending",
      value: statsData?.currentMonthPending,
      icon: UsersIcon
    },
    {
      title: "This Month Payout",
      value: statsData?.currentMonthPayout,
      icon: UsersIcon
    },
    {
      title: "Previous Month Pending",
      value: statsData?.previousMonthPending,
      icon: UsersIcon
    },
    {
      title: "Previous Month Payout ",
      value: statsData?.previousMonthPayout,
      icon: UsersIcon
    },
  ];


  const handleClickAddPayment = (data) => {
    setChitDetailsAddPayment(true)
    setCustomerId(data)
  }

  const handleClose = () => {
    setChitDetailsAddPayment(false)
    fetchData()
  }


  if (loading) {
    return (
      <Loader />
    )
  }

  if (error) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md">
          <div className="flex items-center justify-center mb-6">
            <svg
              className="h-12 w-12 text-red-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          <p className="text-gray-600 mb-8 text-center">
            Please check your internet connection and try again.
          </p>
          <div className="flex justify-center">
            <button
              className="bg-[#0f172a] hover:bg-teal-900 text-white font-semibold py-2 px-4 rounded transition duration-300"
              onClick={() => window.location.reload()}
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    )

  }


  return (
    <div>

      <div className="">
        <div className="sm:flex-auto">
          <h1 className=" font-bold text-3xl text-gray-900">Dashboard</h1>
        </div>
      </div>

      <div className="grid grid-cols-1 mt-4 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6  p-4 px-4">
        {stats?.map((stat, index) => {
          const colors = [
            "border-l-4 border-indigo-500",
            "border-l-4 border-blue-500",
            "border-l-4 border-green-500",
            "border-l-4 border-orange-500",
            "border-l-4 border-pink-500",
            "border-l-4 border-cyan-500",
            "border-l-4 border-emerald-500",
            "border-l-4 border-yellow-500",
          ];
          return (
            <div
              key={index}
              className={`bg-gray-100 p-6 rounded-xl shadow-md hover:shadow-lg   transition ${colors[index % colors.length]}`}
            >
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-sm font-medium text-gray-500">{stat.title}</p>
                  <p className="text-3xl font-extrabold text-gray-900">{stat.value}</p>
                </div>
                <div className="p-3 bg-gray-100 rounded-full">
                  <stat.icon className="h-7 w-7 text-indigo-600" />
                </div>
              </div>
            </div>
          );
        })}
      </div>


      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">


        <div>
          <h2 className="text-xl font-semibold mb-3 text-green-600">
            Current Month Payouts
          </h2>

          <div className="overflow-x-auto border rounded-lg">
            <table className="min-w-full">
              <thead className="bg-green-50">
                <tr>
                  <th className="px-4 py-2 border">#</th>
                  <th className="px-4 py-2 border">Plan</th>
                  <th className="px-4 py-2 border">Group</th>
                  <th className="px-4 py-2 border">Amount</th>
                </tr>
              </thead>

              <tbody>
                {currentMonthPayout?.length > 0 ? (
                  currentMonthPayout.map((item, i) => (
                    <tr key={i} className="text-center hover:bg-gray-50">
                      <td className="px-4 py-2 border">{i + 1}</td>
                      <td className="px-4 py-2 border">{item.plan_name}</td>
                      <td className="px-4 py-2 border">{item.group_name}</td>
                      <td className="px-4 py-2 border font-semibold text-green-600">
                        ₹{item.payable_amount}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center py-3">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>


        <div>
          <h2 className="text-xl font-semibold mb-3 text-indigo-600">
            Previous Month Payouts
          </h2>

          <div className="overflow-x-auto border rounded-lg">
            <table className="min-w-full">
              <thead className="bg-indigo-50">
                <tr>
                  <th className="px-4 py-2 border">#</th>
                  <th className="px-4 py-2 border">Plan</th>
                  <th className="px-4 py-2 border">Group</th>
                  <th className="px-4 py-2 border">Amount</th>
                </tr>
              </thead>

              <tbody>
                {previouMonthPayout?.length > 0 ? (
                  previouMonthPayout.map((item, i) => (
                    <tr key={i} className="text-center hover:bg-gray-50">
                      <td className="px-4 py-2 border">{i + 1}</td>
                      <td className="px-4 py-2 border">{item.plan_name}</td>
                      <td className="px-4 py-2 border">{item.group_name}</td>
                      <td className="px-4 py-2 border font-semibold text-indigo-600">
                        ₹{item.payable_amount}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center py-3">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

      </div>




      <div  >
        <div className="px-4 sm:px-6 lg:px-8 mt-4">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 bg-white p-4  rounded-xl shadow-sm border">

            {/* Title */}
            <h3 className="text-2xl font-bold text-gray-800">
              Chit Details
            </h3>

            {/* Search Section */}
            <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">

              {/* Input */}
              <div className="relative w-full sm:w-72">
                <input
                  type="search"
                  name="search"
                  placeholder="Search name, phone"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="
                  pl-10 pr-4
                  py-2.5
                  border border-gray-300
                  rounded-lg
                  text-sm
                  focus:ring-2 focus:ring-indigo-500
                  focus:border-indigo-500
                  outline-none
                  transition
                  w-full
                  "
                />

                {/* Icon */}
                <svg
                  className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-4.35-4.35m1.85-5.65a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z"
                  />
                </svg>
              </div>

              {/* Button */}
              <button
                type="button"
                onClick={searchFilter}
                className="
        w-full sm:w-auto
        px-4 py-2.5
        text-sm
        bg-[#0f172a] text-white
        rounded-lg
        hover:bg-[#0f172ab8]
        transition
      "
              >
                Search
              </button>

            </div>

          </div>




          <div className="mt-8 flow-root">
            <div className="-mx-2 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 border rounded-md align-middle sm:px-6 lg:px-8">
                <div className="overflow-hidden shadow-sm sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-300 shadow-xl">
                    {/* <thead className=" text-[#649ece] hover:bg-gray-100"> */}
                    <thead className="text-white  bg-[#0f172a]">
                      <tr>
                        <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-sm font-semibold  sm:pl-6">
                          #
                        </th>
                        <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-sm font-semibold  sm:pl-6">
                          Customer Name
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                          Active Plan
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                          Phone Number
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                          Month
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                          Entry Date
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                          Payable Amount
                        </th>

                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                          Payment Status
                        </th>
                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                          Amount Received
                        </th>
                        {/* <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                               Total Amount
                             </th> */}

                        <th scope="col" className="relative py-3.5 pr-4 pl-3 sm:pr-6">
                          Action
                        </th>
                      </tr>
                    </thead>


                    <tbody className="divide-y divide-gray-200 bg-white">

                      {formData?.map((person, index) => (
                        <tr key={index}
                          className={`hover:bg-gray-100`}
                        >
                          <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">

                            {index + 1}
                          </td>
                          <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">

                            {person?.customer?.name || "N/A"}
                          </td>
                          <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                            {person.active_plan?.plan.name + "-" + person.active_plan?.group.group_name || "N/A"}
                          </td>

                          <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">{person?.customer?.phone || "N/A"}</td>
                          <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">{person.month || "N/A"}</td>
                          <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">{new Date(person.entry_date).toLocaleDateString("en-GB") || "N/A"}</td>
                          <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">{person.payable_amount || "0"}</td>

                          <td className="px-3 py-4 text-sm whitespace-nowrap">
                            <span
                              className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full
                                       ${person.payment_status == "unpaid" ? "bg-red-200 text-red-800" : ""}
                                       ${person.payment_status == "Paid" ? "bg-green-200 text-green-600" : ""}
                                       ${person.payment_status == "Partially Paid" ? "bg-yellow-200 text-yellow-600" : ""}
                                     `}
                            >
                              {person.payment_status}
                            </span>
                          </td>

                          <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">{person.amount_received}</td>


                          <td className="px-3 py-4 p-2  text-center text-sm font-medium whitespace-nowrap sm:pr-6 gap-2">
                            <div className='flex gap-2'>


                              <button
                                type="button"
                                className=" rounded bg-white px-5 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-100"

                                onClick={() =>
                                  handleClickAddPayment(person)
                                }
                              >
                                Add payment
                              </button>



                            </div>

                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>



      <Transition.Root show={chitDetailsAddPayment} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={setChitDetailsAddPayment}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-md lg:max-w-screen-lg sm:w-full">
                  <div>
                    <ChitDetailsAddPayment
                      close={handleClose}
                      chitData={customerId}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>










    </div>
  )
}

export default DashboardList
